<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Turmas do Instrutor</h5>
    </div>

    <!-- Filtros -->
    <div class="d-flex mb-3" style="gap: 10px;">
      <input
        v-model="filters.instrutor"
        placeholder="Filtrar por Instrutor"
        class="form-control"
        @input="filtrar"
      />
      <input
        v-model="filters.nivel"
        placeholder="Filtrar por Nível"
        class="form-control"
        @input="filtrar"
      />
      <b-form-select
        v-model="filters.dia"
        :options="diasOptions"
        class="form-control"
        @change="filtrar"
      />
      <b-button variant="secondary" @click="limparFiltros" class="d-flex align-items-center justify-content-center">
        <i class="bi bi-funnel mr-2" title="Limpar Filtro"></i>
      </b-button>
    </div>

    <!-- Tabela nativa com ordenação -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="sort('turma')">
              Turma {{ arrow('turma') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('instrutor')">
              Instrutor {{ arrow('instrutor') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('horario')">
              Horário {{ arrow('horario') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('nivel')">
              Nível {{ arrow('nivel') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('dias')">
              Dias {{ arrow('dias') }}
            </button>
          </th>
          <th>Alunos</th>
          <th class="text-end">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.uniqueId">
          <td>{{ item.turma }}</td>
          <td>{{ item.instrutor }}</td>
          <td>{{ item.horario }}</td>
          <td>{{ item.nivel }}</td>
          <td>{{ item.dias }}</td>
          <td>
            <span>{{ item.matriculados }}</span>
            <span v-if="item.reposicao > 0" class="text-primary">({{ item.reposicao }})</span>
            <span v-if="item.experimental > 0" class="text-success">({{ item.experimental }})</span>
            <span v-if="item.avulsa > 0" class="text-warning">({{ item.avulsa }})</span>
          </td>
          <td class="text-end">
            <i
              v-if="hasPermission('detalhar_turmas_instrutor')"
              class="bi bi-eye-fill text-primary mx-2"
              title="Detalhar Turma"
              @click="abrirDetalhar(item)"
            ></i>
            <i
              v-if="hasPermission('registrar_chamada')"
              class="bi bi-pencil-square text-info mx-2"
              title="Registrar Chamada"
              @click="registrarChamada(item)"
            ></i>
            <i
              v-if="hasPermission('imprimir_chamada')"
              class="bi bi-printer text-secondary mx-2"
              title="Imprimir Chamada em Branco"
              @click="imprimirChamada(item)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <!-- resumo -->
      <div>
        Mostrando {{ startRow }} a {{ endRow }} de {{ totalItems }} registros
      </div>

      <!-- seletor de itens por página -->
      <div class="d-flex align-items-center" style="gap: .5rem;">
        <b-form-select
          v-model="limit"
          :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
          size="sm"
          style="width: 6rem"
        />
      </div>

      <!-- controle de página -->
      <div class="d-flex align-items-center">
        <b-pagination
          v-model="page"
          :per-page="limit"
          :total-rows="totalItems"
          size="sm"
          limit="5"
        />
      </div>
    </div>

    <!-- Modais -->
    <RegistrarChamada
      v-if="showModalChamada"
      :turma="selectedTurma"
      @salvou="handleChamadaSalva"
      @cancelar="showModalChamada = false"
    />
    <ImprimirChamada
      v-if="showModalImprimirChamada"
      :turma="selectedTurma"
      :alunosMatriculados="selectedAlunosMatriculados"
      :alunosExperimentais="selectedAlunosExperimentais"
      :alunosAvulsos="selectedAlunosAvulsos"
      @cancelar="showModalImprimirChamada = false"
    />
    <DetalharTurmaInstrutor
      v-if="showModalDetalhar"
      :id="selectedUniqueId"
      @fechar="showModalDetalhar = false"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
// import { useRouter } from 'vue-router';
import { useSortableTable } from '@/utils/useSortableTable';
import { usePermissions } from '@/composables/usePermissions';
import { BButton, BFormSelect, BPagination } from 'bootstrap-vue-next';
import RegistrarChamada from '@/components/modals/RegistrarChamada.vue';
import ImprimirChamada from '@/components/modals/ImprimirChamada.vue';
import DetalharTurmaInstrutor from '@/components/Operacional/TurmasInstrutor/DetalharTurmaInstrutor.vue';
// import axios from '@/services/axios'

// modal de detalhes
const showModalDetalhar = ref(false);
const selectedUniqueId = ref(null);

// slugify inline
function slugify(text) {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/:/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase();
}

const diasOptions = [
  { value: '',               text: 'Todos os dias' },
  { value: 'segunda-feira',  text: 'Segunda-feira' },
  { value: 'terça-feira',    text: 'Terça-feira' },
  { value: 'quarta-feira',   text: 'Quarta-feira' },
  { value: 'quinta-feira',   text: 'Quinta-feira' },
  { value: 'sexta-feira',    text: 'Sexta-feira' },
  { value: 'sábado',         text: 'Sábado' },
  { value: 'domingo',        text: 'Domingo' },
];

// navegação e permissões
// const router = useRouter();
const { fetchPermissions, hasPermission } = usePermissions();

// composable de tabela (paginação, filtros, ordenação)
const {
  items,
  // totalPages,
  totalItems,
  page,
  limit,
  filters,
  // currentSort,
  sort,
  arrow,
  load,
  // goPrev,
  // goNext
} = useSortableTable('/operacional/turmas-instrutor', {
  key: 'turma',
  order: 'asc'
});

// dropdown de páginas
const pageOptions = [10,15,20,25,50];

// computeds de resumo
const startRow = computed(() =>
  (page.value - 1) * limit.value + 1
);
const endRow = computed(() =>
  Math.min(page.value * limit.value, totalItems.value)
);

function ensureUniqueId() {
  if (!Array.isArray(items.value) || !items.value.length) return;
  if (items.value.some(it => !it.uniqueId)) {
    applySlug();
  }
}

watch(items, () => {
  ensureUniqueId();
});


// recarrega ao mudar página/limite
watch(page,  () => load().then(applySlug));
watch(limit, () => {
  page.value = 1;
  load().then(applySlug);
});

// inicializa filtros
Object.assign(filters.value, { instrutor: '', nivel: '', dia: '' });

// mapeia uniqueId após carregar
function applySlug() {
  items.value = items.value.map(item => ({
    ...item,
    uniqueId: `${item.turma}|${slugify(item.dias)}|${slugify(item.horario)}|${encodeURIComponent(item.instrutor)}`
  }));
}

// filtros
function filtrar() {
  page.value = 1;
  load().then(applySlug);
}
function limparFiltros() {
  page.value = 1;
  Object.assign(filters.value, { instrutor: '', nivel: '', dia: '' });
  load().then(applySlug);
}

function makeUniqueId(item) {
  // mantém seu padrão de slug (igual ao applySlug)
  const s = (t) => t
    ? t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/:/g, '').replace(/\s+/g, '-').toLowerCase()
    : '';
  return `${item.turma}|${s(item.dias)}|${s(item.horario)}|${encodeURIComponent(item.instrutor || '')}`;
}

function abrirDetalhar(item) {
  const id = item.uniqueId || makeUniqueId(item);
  selectedUniqueId.value = id;
  showModalDetalhar.value = true;
}

// modais de chamada
const showModalChamada = ref(false);
const showModalImprimirChamada = ref(false);
const selectedTurma = ref(null);
const selectedAlunosMatriculados = ref([]);
const selectedAlunosExperimentais = ref([]);
const selectedAlunosAvulsos = ref([]);

async function registrarChamada(item) {
  // 1) Preenche o objeto da turma já com nivel_id
  selectedTurma.value = {
    ...item,
    // item.nivel_id deve vir do SELECT que agora inclui "nt.id AS nivel_id"
  };

  // 2) Popula os arrays de alunos conforme antes
  selectedAlunosMatriculados.value = item.alunosMatriculados || [];
  selectedAlunosExperimentais.value = item.alunosExperimentais || [];
  selectedAlunosAvulsos.value = item.alunosAvulsos || [];

  // 3) Abre o modal
  showModalChamada.value = true;
}

function imprimirChamada(item) {
  selectedTurma.value = item;
  selectedAlunosMatriculados.value = item.alunosMatriculados || [];
  selectedAlunosExperimentais.value = item.alunosExperimentais || [];
  selectedAlunosAvulsos.value = item.alunosAvulsos || [];
  showModalImprimirChamada.value = true;
}

function handleChamadaSalva() {
  showModalChamada.value = false;
  load().then(applySlug);
}

onMounted(async () => {
  await fetchPermissions();
  await load();
  applySlug();
});
</script>

<style scoped>
.same-height {
  height: 30px;
  padding: 6px 12px;
  font-size: .72rem;
}

:deep(.pagination.pagination-sm .page-link) {
  padding: rem rem;
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}

</style>
